(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Anchor', Anchor);

    /* @ngInject */
    function Anchor($resource) {
        var resourceUrl = 'api/airnotes/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
